import { render, staticRenderFns } from "./helpPayFor.vue?vue&type=template&id=6c94763b&"
import script from "./helpPayFor.vue?vue&type=script&lang=js&"
export * from "./helpPayFor.vue?vue&type=script&lang=js&"
import style0 from "./helpPayFor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports